class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.endDate = new Date(this.getAttribute('data-end-date')).getTime();
    if (isNaN(this.endDate)) return;

    this.replacementText = this.getAttribute('data-replacement-text') || '';
    this.textElement = this.querySelector('[data-countdown-text]');
    this.countdownElement = this.querySelector('[data-countdown]');

    // Threshold in hours - when to switch from days to hours/minutes/seconds
    // Default: 48 hours (2 days)
    this.switchThreshold = parseInt(this.getAttribute('data-switch-threshold') || '48', 10);

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate - now;

    if (distance < 0) {
      clearInterval(this.interval);
      if (this.textElement && this.replacementText) {
        this.textElement.innerHTML = this.replacementText;
      }
      if (this.countdownElement) {
        this.countdownElement.textContent = '';
      }
      return;
    }

    if (!this.countdownElement) return;

    const totalHours = Math.floor(distance / (1000 * 60 * 60));
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    // const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Show days if we're above the threshold
    if (totalHours >= this.switchThreshold) {
      const dayText = days === 1 ? 'DAY' : 'DAYS';
      this.countdownElement.textContent = `${days} ${dayText}`;
    } else {
      // Show hours, minutes, and seconds when below threshold
      const h = String(totalHours).padStart(2, '0');
      const m = String(minutes).padStart(2, '0');
      const s = String(seconds).padStart(2, '0');
      this.countdownElement.textContent = `${h}H ${m}M ${s}S`;
    }
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);
